<script lang="ts">
    import {Vue, Component} from 'vue-facing-decorator'

    @Component
    export class SupplierFilter extends Vue {
        render() {
            return null
        }
    }

    export default SupplierFilter
</script>
